import * as React from 'react';
export const DefaultSvg = ()=>/*#__PURE__*/ React.createElement("svg", {
        className: "fui-Spinner__Progressbar"
    }, /*#__PURE__*/ React.createElement("circle", {
        className: "fui-Spinner__Track"
    }), /*#__PURE__*/ React.createElement("circle", {
        className: "fui-Spinner__Tail"
    }));
